(function() {
    const contentLists = document.querySelectorAll('#content > ul.two');

    if ( ! contentLists ) {
        return;
    }

    for ( let i = 0; i < contentLists.length; i++ ) {
        const children      = Array.from(contentLists[i].children);
        const maxInColumn   = parseInt(children.length / 2);
        const firstColumn   = createUL(children.slice(0, maxInColumn));
        const secondColumn  = createUL(children.slice(maxInColumn, -1));

        const wrapper       = document.createElement('div');
        wrapper.className = 'two-cols-list';
        wrapper.appendChild(firstColumn);
        wrapper.appendChild(secondColumn);

        contentLists[i].replaceWith(wrapper);
    }

    function createUL(children) {
        const UL = document.createElement('ul');
        Array.from(children).forEach(function(item) {
            UL.appendChild(item);
        });
        return UL;
    }
})();